import { site } from '../data/site'

export default function Footer() {
  return (
    <footer className="border-t border-black/5 bg-white">
      <div className="w-full px-6 sm:px-10 lg:px-16 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-navy/60">
        <div className="flex items-center gap-2">
          <img src="/NPDT로고.png" className="w-5 h-5" alt="" />
          <span>
            © {new Date().getFullYear()} {site.name} · {site.lab}
          </span>
        </div>
        <div className="flex items-center gap-4">
          <a href={site.github} target="_blank" rel="noreferrer" className="hover:text-brand">
            GitHub
          </a>
          <a href={`mailto:${site.email}`} className="hover:text-brand">
            {site.email}
          </a>
          <a href={site.dashboardUrl} className="hover:text-brand">
            Dashboard ↗
          </a>
        </div>
      </div>
    </footer>
  )
}
